import React from 'react';
import { FooterOverlay,Newsletter } from '../../components';
import {FiFacebook,FiTwitter,FiInstagram} from 'react-icons/fi';
import {BiSolidMap} from 'react-icons/bi'


import './Footer.css';
import { images } from '../../constants';

const Footer = () => (
  <div className='app__footer section__padding'>
    <FooterOverlay/>
    <Newsletter/>

    <div className='app__footer-links'>
      <div className='app__footer-links_contact'>
        <h1 className='app__footer-headtext'>Contact Us</h1>
        <p className='p__opensans'><BiSolidMap/> Urdu Mohallah Rajopatti Dumra Road Sitamarhi</p>
        <p className='p__opensans'> 9525348835</p>
        <p className='p__opensans'> 9931752810</p>

      </div>
      <div className='app__footer-links_logo'>
        <img src={images.gericht} alt="footer__logo" />
        <p className='p__opensans'>"The Best Way to Find yourself is to lose yourself in the Service of others."</p>
        <img src={images.spoon} alt="spoon" className='spoon__img' style={{marginTop:"15"}} />
        <div className='app__footer-links_icons'>
          <FiFacebook/>
          <FiInstagram/>
          <FiTwitter/>


        </div>

      </div>
      <div className='app__footer-links_work'>
      <h1 className='app__footer-headtext'>Working Hours</h1>
        <p className='p__opensans'>Monday-Friday:</p>
        <p className='p__opensans'>08:00 Am-12:00 Am</p>
        <p className='p__opensans'>Saturday-Sunday:</p>
        <p className='p__opensans'>07:00 Am-02:00 Am</p>

      </div>

    </div>

    <div className='footer__copyright'>
      <p className='p__opensans'>2023 Arzoo Restaurant.All rights reserved.</p>
    </div>


  </div>
);

export default Footer;
